export const m = {
  append: '新增',
  delete: '删除',
  batchDelete: '批量删除',
  editor: '编辑',
  query:'查询',
  cancel:'取消',
  confirmAppend:'确认新增',
  confirmEditor:'确认修改',
}



// WEBPACK FOOTER //
// ./src/assets/zh.js